export function documentDisplayTitle(document:  DocumentSnakeModel) {
  return `${documentDisplayNumber(document)} | ${document.title}`;
}

export function documentDisplayNumber(document: DocumentSnakeModel) {
  let displayId = `${document.id}`;
  if (document.non_ai_document_id) {
    displayId = `${document.non_ai_document_id} AI`;
  }

  return displayId;
}
